import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
const posts = [{
  img: IMAGES.cheesecake,
  label: 'The first bake',
  num: '01'
}, {
  img: IMAGES.box,
  label: 'The signature box',
  num: '02'
}, {
  img: IMAGES.cheesecake,
  label: 'A slice of heaven',
  num: '03'
}];
export function Instagram() {
  return <section className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-123">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-10 items-end mb-20 lg:mb-28" data-id="element-125">
          <div className="lg:col-span-8" data-id="element-126">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-127">
              <span className="w-10 h-px bg-caramel/40" data-id="element-128" />
              @tartahtx
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-129">
              Follow the
              <br data-id="element-130" />
              <span className="italic font-extralight" data-id="element-131">First Chapter.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:text-right" data-id="element-132">
            <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="group inline-flex items-center gap-4 text-[11px] tracking-[0.3em] uppercase text-cream" data-id="element-133">
              <span className="relative pb-1" data-id="element-134">
                Follow @tartahtx
                <span className="absolute bottom-0 left-0 right-0 h-px bg-cream group-hover:bg-caramel transition-colors duration-500" data-id="element-135" />
              </span>
              <span className="w-10 h-px bg-cream group-hover:bg-caramel group-hover:w-14 transition-all duration-500" data-id="element-136" />
            </a>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-10" data-id="element-137">
          {posts.map((p, i) => <motion.a key={i} href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.9,
          delay: i * 0.12
        }} className="group block" data-id="element-138">
              <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-139">
                <img src={p.img} alt={p.label} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.05]" data-id="element-140" />
              </div>
              <div className="mt-5 flex items-baseline justify-between text-[10px] tracking-[0.3em] uppercase" data-id="element-141">
                <span className="font-serif text-caramel" data-id="element-142">{p.num}</span>
                <span className="text-cream/50 group-hover:text-cream transition-colors duration-500" data-id="element-143">
                  {p.label}
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}